/*
 * @author        zach.william@zumper.com (Zach William)
 * @copyright     Copyright (c) 2023, Zumper
 * @description   NZRUnitsTableLazyLoadableSection.tsx
 */

/** @jsx jsx */
import { css, jsx } from '@emotion/react'
import { createLazyLoadableSection } from '@zcode/lazy-loadable-section'
import { ErrorFallback, LoadingFallback } from '@zcode/nr/es/shared/components/Fallback'

import { logger } from '../../logger'

const style = css`
  height: ${139 + 169 * 3}px;
  @media (min-width: 881px) {
    height: ${177 + 121 * 3}px;
  }
`

const loadFn = /* #__LOADABLE__ */ async () =>
  await import(/* webpackChunkName: "NZRUnitsTable" */ './NZRUnitsTable')

const onLoadingError = (error: unknown) => {
  logger.error('loading error for NZRUnitsTable', error)
}

const handleReload = () => {
  try {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    NZRUnitsTableLazyLoadableSection.reload()
  } catch (error) {
    logger.info('Failed to reload NZRUnitsTable', error)
  }
}

const options = {
  errorFallback: () => <ErrorFallback message="Error loading units" onClickReload={handleReload} />,
  loadingFallback: () => <LoadingFallback css={style} name="units" />,
  onLoadingError,
}

export const NZRUnitsTableLazyLoadableSection = createLazyLoadableSection(loadFn, options)
